module.exports = __webpack_public_path__ + "static/img/demo_page.683607e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/demo_page.png
// module id = SOR2
// module chunks = 31